import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function Counter() {
  return {
    init: () => {
      const counters = document.querySelectorAll('[data-w-counter]');

      counters.forEach((counter) => {
        const parent = counter.closest('.w-b-counter');
        const digits = counter.querySelectorAll('& > * > *');
        digits.forEach((digit, index) => {
          const targetDigit = digit.querySelector('span');
          const targetDigitValue = parseInt(targetDigit.textContent, 10);
          const clonedDigits = Array.from(
            { length: (index + 1) * 2 },
            (_, i) => {
              const newDigit = targetDigit.cloneNode();
              let newDigitValue = targetDigitValue - 1 - i;
              if (newDigitValue < 0) newDigitValue = 10 + newDigitValue; // restart from 9 after 0 when counting digit down
              newDigit.textContent = newDigitValue;
              return newDigit;
            }
          );
          clonedDigits.reverse();
          clonedDigits.forEach((item) => targetDigit.before(item));
        });

        gsap.to(digits, {
          yPercent: -100,
          duration: 2,
          ease: 'power4.out',
          stagger: {
            each: 0.25,
          },
          scrollTrigger: {
            trigger: parent,
            start: 'top bottom',
            end: 'top 20%',
            scrub: 2,
            markers: false,
          },
        });
      });
    },
  };
}
